import { authenticate as xAuthenticate } from '@nab/x-auth';
import { runtimeEventBus } from '../services/runtimeEventBus';
import { loadApp, getAuthConfig } from '../core';
import { getAuthConfigForInstanceId } from '../registries/instanceRegistry';
export function defaultActionsProvider(app, instanceId) {
    return {
        navigate: (uri, data) => {
            Object.assign(window.location, { href: uri });
            return Promise.resolve();
        },
        authenticate: (configOverridesOrForceRefresh, forceRefresh = false) => {
            let configOverrides = {};
            const authConfig = getAuthConfigForInstanceId(instanceId);
            if (typeof configOverridesOrForceRefresh === 'boolean') {
                // eslint-disable-next-line no-param-reassign
                forceRefresh = configOverridesOrForceRefresh;
            }
            else {
                configOverrides = configOverridesOrForceRefresh || {};
            }
            const config = {
                ...getAuthConfig(),
                ...(authConfig || {}),
                appMetaData: app,
                ...configOverrides
            };
            return xAuthenticate(config, forceRefresh);
        },
        dispatchEvent: (eventNameOrConfig, data) => {
            return runtimeEventBus.publish(instanceId, eventNameOrConfig, data);
        },
        addEventListener: (eventNameOrConfig, listener) => {
            return runtimeEventBus.subscribe(instanceId, eventNameOrConfig, listener);
        },
        removeEventListener: (eventName, listener) => {
            return runtimeEventBus.unsubscribe(instanceId, eventName, listener);
        },
        embedMiniApp: (...args) => {
            const appLoaderConfig = args.length === 1
                ? args[0]
                : {
                    hostElement: args[1],
                    appMetaData: args[0]
                };
            appLoaderConfig.appMetaData.parentContext = {
                ...appLoaderConfig.appMetaData.parentContext,
                appMetaData: {
                    id: app.id,
                    name: app.name,
                    route: app.route,
                    description: app.description
                }
            };
            // @ts-ignore
            return loadApp(appLoaderConfig); // eslint-disable-line
        }
    };
}
//# sourceMappingURL=defaultActionsProvider.js.map